import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { payloadGlobalPlayerLifetimeRule } from "../../store/admin/wlCreator";


const getList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getThemes = (platformId: string | number) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.getThemes.replace("{platformId}", `${platformId}`);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateTheme = (platformId: string | number, data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.updateTheme.replace("{platformId}", `${platformId}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('PUT', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const uploadImages = (platformId: string | number, data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.uploadImages.replace("{platformId}", `${platformId}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCreateOptions = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.wlCreator.createOptions}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const create = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.create;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFilterCreator = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.filterCreators;

  const payload = {
    ...data,
    authenticity_token,
  };

  return fetch(`${endpoint}`, { ...RequestOptions('POST', JSON.stringify(payload)) })
    .then(handleResponse)
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return error;
    });
};


const getPlatformConfig = (platformId: string) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.getPlatformConfig.replace('{platformId}', platformId);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updatePlatformConfig = (platformId: string, data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.updatePlatformConfig.replace('{platformId}', platformId);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('PUT', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getMarketingConfig = (platformId: string) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.getMarketing.replace('{platformId}', platformId);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateMarketingConfig = (platformId: string, data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.updateMarketing.replace('{platformId}', platformId);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('PUT', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getProvisioningSteps = (platformId: string | number) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.provisioningSteps.replace("{platformId}", `${platformId}`);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getDomainsConfig = (platformId: string) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.getDomains.replace('{platformId}', platformId);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateDomainsConfig = (platformId: string, data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.updateDomains.replace('{platformId}', platformId);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};
const setDefaultClickDomain = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.setDefaultClickDomain
    .replace('{platformId}', data.platformId)
    .replace('{clickDomainId}', `${data.clickDomainId}`);

  const payload = {
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getGlobalPlayerLifetimeRules = ({ platformId, ...data }: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.globalPlayerLifetimeRulesList.replace('{platformId}', platformId);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createGlobalPlayerLifetimeRule = (platformId: string, data: payloadGlobalPlayerLifetimeRule) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.globalPlayerLifetimeRules.replace('{platformId}', platformId);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateGlobalPlayerLifetimeRule = (platformId: string, id: number | string, data: payloadGlobalPlayerLifetimeRule) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.globalPlayerLifetimeRule
    .replace('{platformId}', platformId)
    .replace('{id}', `${id}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const deleteGlobalPlayerLifetimeRule = (platformId: string, id: number | string) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.globalPlayerLifetimeRule
    .replace('{platformId}', platformId)
    .replace('{id}', `${id}`);

  const payload = {
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('DELETE', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const wlCreatorService = {
	getList,
  getCreateOptions,
  create,
  getFilterCreator,
  getPlatformConfig,
  updatePlatformConfig,
  getMarketingConfig,
  updateMarketingConfig,
  getThemes,
  updateTheme,
  uploadImages,
  getProvisioningSteps,
  getDomainsConfig,
  updateDomainsConfig,
  setDefaultClickDomain,
  getGlobalPlayerLifetimeRules,
  createGlobalPlayerLifetimeRule,
  updateGlobalPlayerLifetimeRule,
  deleteGlobalPlayerLifetimeRule,
};
